import { render, staticRenderFns } from "./BtnRemoverItemSelecionado.vue?vue&type=template&id=d0a59992"
import script from "./BtnRemoverItemSelecionado.vue?vue&type=script&lang=js"
export * from "./BtnRemoverItemSelecionado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports